import { CareType } from '@/types/care_type';

export enum AgeGroups {
  INFANT = 'INFANT',
  TODDLER = 'TODDLER',
  PRE_SCHOOL = 'PRE_SCHOOL',
  ELEMENTARY = 'ELEMENTARY',
  JUNIOR_HIGH = 'JUNIOR_HIGH',
}

export enum DaysOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export enum EmploymentTypes {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME',
}

export enum Requirements {
  COMFORTABLE_WITH_PETS = 'COMFORTABLE_WITH_PETS',
  HAS_A_CAR = 'HAS_A_CAR',
  LANGUAGES_SPOKEN = 'LANGUAGES_SPOKEN',
  MULTIPLES_EXPERIENCE = 'MULTIPLES_EXPERIENCE',
  SPECIAL_NEEDS_EXPERIENCE = 'SPECIAL_NEEDS_EXPERIENCE',
}

export enum Responsibilities {
  DRIVING_THE_KIDS = 'DRIVING_THE_KIDS',
  HOMEWORK_HELP = 'HOMEWORK_HELP',
  PREPARE_SNACKS_MEALS = 'PREPARE_SNACKS_MEALS',
  LIGHT_HOUSEWORK = 'LIGHT_HOUSEWORK',
  DO_LAUNDRY = 'DO_LAUNDRY',
  RUN_ERRANDS = 'RUN_ERRANDS',
  SLEEP_TRAINING = 'SLEEP_TRAINING',
  POTTY_TRAINING = 'POTTY_TRAINING',
  SICK_CARE = 'SICK_CARE',
  NANNY_SHARE = 'NANNY_SHARE',
  LEARNING_POD = 'LEARNING_POD',
  TUTORING = 'TUTORING',
}

export enum Languages {
  ARA = 'ara',
  ZHO = 'zho',
  FRA = 'fra',
  DEU = 'deu',
  ELL = 'ell',
  HEB = 'heb',
  HIN = 'hin',
  ITA = 'ita',
  JPN = 'jpn',
  KOR = 'kor',
  POR = 'por',
  RUS = 'rus',
  ASE = 'ase',
  SPA = 'spa',
}

export enum NannyHours {
  WEEKDAY_MORNING = 'WEEKDAY_MORNING',
  WEEKDAY_DAY = 'WEEKDAY_DAY',
  WEEKDAY_AFTERNOON = 'WEEKDAY_AFTERNOON',
  WEEKDAY_EVENING = 'WEEKDAY_EVENING',
  WEEKENDS_DAY = 'WEEKENDS_DAY',
  WEEKENDS_EVENING = 'WEEKENDS_EVENING',
}

export interface Location {
  x: number;
  y: number;
}

export interface FixedPaymentRate {
  paymentRate: number;
  paymentRateType: string;
}

export interface RangePaymentRate {
  max: number;
  min: number;
  paymentRateType: 'hour';
}

export interface PaymentRate {
  fixedPaymentRate?: FixedPaymentRate;
  rangePaymentRate?: RangePaymentRate;
}

export interface RegularJobSchedule {
  days: DaysOfWeek[];
  endTime: string;
  isStartDateFlexible: boolean;
  isStartTimeFlexible: boolean;
  startDate: string;
  startTime: string;
}

export interface OneTimeJobSchedule {
  endTime: string;
  isStartTimeFlexible: boolean;
  startDate: string;
  startTime: string;
}

export interface OccasionalJobSchedule {
  isStartDateFlexible: boolean;
  startDate: string;
}

export interface NannyJobSchedule {
  employmentType: EmploymentTypes;
  hours: NannyHours[];
  isStartDateFlexible: boolean;
  startDate: string;
  startTime: string;
  endTime: string;
}

export type Schedule = {
  regularJobSchedule?: RegularJobSchedule;
  oneTimeJobSchedule?: OneTimeJobSchedule;
  occasionalJobSchedule?: OccasionalJobSchedule;
  nannyJobSchedule?: NannyJobSchedule;
};

export interface JobPostMutationInput {
  ageGroups?: AgeGroups[];
  aiGenerated?: boolean;
  description?: string;
  languages?: Languages[];
  location?: Location | null;
  numberOfChildren?: number | null;
  paymentRate?: PaymentRate | null;
  requirements?: Requirements[];
  responsibilities?: Responsibilities[];
  schedule?: Schedule | null;
  title?: string;
  careType?: CareType.BABYSITTER | CareType.NANNY; // these are the only two care types currently supported for create job mutation
}

export type JobState = Record<string, never>;
